import { Select } from "@chakra-ui/react";
import { FiChevronDown } from "react-icons/fi";

export default function GlassSelect({
  value,
  onChange,
  options = [],
  placeholder,
  children,
  ...rest
}) {
  return (
    <Select
      bg="glass.field"
      value={value}
      onChange={onChange}
      borderRadius="control"
      color="text.onGlass"
      icon={<FiChevronDown />}
      border="1px solid"
      borderColor="blackAlpha.200"
      _hover={{ borderColor: "blackAlpha.300" }}
      _focus={{
        bg: "rgba(255, 255, 255, 0.96)",
        borderColor: "brand.500",
        boxShadow: "focus",
      }}
      placeholder={placeholder}
      sx={{
        "& option": {
          bg: "#ffffff",
          color: "#2d3748",
        },
      }}
      {...rest}
    >
      {children ||
        options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
    </Select>
  );
}
